<app-prism-xml [xmlData]="xml"></app-prism-xml>
